import { FunctionComponent } from "react";
import MobileAuthButtons from "../MobileAuthButtons";
import HeroContent from "./HeroContent";
import HeroImage from "./HeroImage";


const Header: FunctionComponent = () => (
  <div>
    <MobileAuthButtons />
    <header className="w-full bg-primary flex flex-col-reverse lg:h-[500px] lg:p-10 lg:flex-row relative">
      <HeroContent />
      <HeroImage />
    </header>
  </div>
);


export default Header;



